import { render, staticRenderFns } from "./ListTaxiFeeRule.vue?vue&type=template&id=1f7e7a0c&"
import script from "./ListTaxiFeeRule.vue?vue&type=script&lang=js&"
export * from "./ListTaxiFeeRule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports